module.exports = __webpack_public_path__ + "static/media/system-ready-logo.bebc66c6.png";